// Pure helpers for the AdminOverviewPage — extracted to remove nested
// ternaries from the JSX and make the logic unit-testable.

// Returns the Tailwind class for the per-domain progress bar.
export const domainBarColor = (pct, isGrading) => {
  if (pct === 100) return 'bg-emerald-500';
  if (isGrading) return 'bg-teal-400';
  if (pct > 50) return 'bg-teal-500';
  if (pct > 0) return 'bg-amber-400';
  return 'bg-white/20';
};

// Returns the Tailwind class for the overall (top) progress bar.
export const overallBarColor = (pct, domainsGrading) => {
  if (pct === 100) return 'bg-emerald-500';
  if (domainsGrading > 0) return 'bg-teal-400';
  if (pct > 60) return 'bg-teal-500';
  if (pct > 20) return 'bg-amber-400';
  return 'bg-rose-400';
};

// Returns the Tailwind class trio for the small status pill on each
// customer-domain row in the bottom list.
export const customerStatusPillClass = (status) => {
  if (status === 'active') return 'bg-green-500/20 text-green-400';
  if (status === 'syncing') return 'bg-yellow-500/20 text-yellow-400';
  return 'bg-white/10 text-white/30';
};

// Stat-card icon background color for the top of each row.
export const statCardColor = (variant) => {
  if (variant === 'teal') return 'bg-teal-500/20';
  if (variant === 'blue') return 'bg-blue-500/20';
  return 'bg-violet-500/20';
};
